import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from './shared/contexts/ThemeContext';
import AppRoutes from './AppRoutes';
import './shared/styles/global.css';
import './shared/styles/app-header.css';
import './hub/styles/hub.css';
import './apps/horario/styles/horario.css';

export default function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </ThemeProvider>
  );
}
